import { Outlet } from 'react-router-dom'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'
import HistoryToolbarGroup from '~/components/HistoryToolbarGroup'
import Toolbar from '~/components/UIKit/Toolbar'
import ZoomToolbarGroup from '~/components/ZoomToolbarGroup'
import MiddleCenter from '~/screens/FacilityScreen/MiddleCenter'
import TopCenter from '~/screens/FacilityScreen/TopCenter'
import { TopLeft } from '~/screens/FacilityScreen/TopLeft'
import TopRight from '~/screens/FacilityScreen/TopRight'
import { useAppSelector } from '~/store/hooks'

export const AppBar = () => {
  const isFullscreen = useAppSelector(state => state.userInterface.isFullscreen)
  return (
    <FacilityScreenContainer>
      {!isFullscreen && (
        <>
          <Toolbar size="xl">
            <TopLeft />
            <TopCenter />
            <TopRight />
          </Toolbar>
          <Toolbar variant="dark">
            <HistoryToolbarGroup />
            <MiddleCenter />
            <ZoomToolbarGroup />
          </Toolbar>
        </>
      )}
      <Outlet />
    </FacilityScreenContainer>
  )
}
